import Vue from "vue";
import {Portlet, Modal, isAuthenticated,DataTable} from 'motivate-framework-components'
import { deviations } from './../../mixins/deviation'
Vue.mixin(deviations)
Vue.component('portlet', Portlet);
Vue.component('modal', Modal);
Vue.component('datatables', DataTable);
Vue.component('isAuthenticated', isAuthenticated);


